import classNames from 'classnames'
import { FieldValues, useController, UseControllerProps } from 'react-hook-form'
import { Input } from '..'
import { InputProps } from '../Input'
import { Form } from './Form'
import camelCase from 'lodash/camelCase'
import { useIntl } from 'react-intl'

type DisplayNameInputProps<T extends FieldValues> = Pick<
  UseControllerProps<T>,
  'control' | 'rules' | 'name'
> & {
  className?: string
} & InputProps

export function DisplayNameInput<T extends FieldValues>({
  name,
  control,
  className,
  rules,
  ...props
}: DisplayNameInputProps<T>) {
  const intl = useIntl()
  const { field, fieldState } = useController<T>({
    name,
    control,
    rules: {
      required: intl.formatMessage({
        id: 'boarding.form.displayName.required',
        defaultMessage: 'Enter your name to continue.',
      }),
    },
  })
  return (
    <>
      <Input
        className={classNames('margin-vertical-8', className)}
        type="name"
        autoComplete="name"
        placeholder="John Doe"
        error={fieldState.invalid}
        data-test-id={camelCase(`${name} field`)}
        {...field}
        {...props}
      />
      <Form.Error message={fieldState.error?.message} />
    </>
  )
}
